
import Vue from "vue";
// @ts-ignore
import FlipCountdown from "vue2-flip-countdown";

import { timeToStart } from "@/config/registrationWindow";

export default Vue.extend({
  name: "WaitCountdown",
  components: { FlipCountdown },

  props: {
    ended: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    timeToStart,
    usmfLogo: require("@/assets/images/usmf-logo.png"),
    labels: {
      days: "Zile",
      hours: "Ore",
      minutes: "Minute",
      seconds: "Secunde",
    },
  }),

  computed: {
    startDateText(): string {
      const months = [
        "ianuarie", "februarie", "martie", "aprilie", "mai", "iunie",
        "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie",
      ];
      const d = new Date(this.timeToStart);
      const day = d.getDate();
      const month = months[d.getMonth()];
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${day} ${month} ${year}, ora ${hours}:${minutes}`;
    },
  },
});
